import React, { useEffect, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

// images
import hero from "./Images/hero.svg";
import image1 from "./Images/galleryimage1.svg";
import image2 from "./Images/galleryimage2.svg";
import image3 from "./Images/galleryimage3.svg";

//icons
import { FaHome } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { blogs } from "../../Blogs copy/BlogData";
import BlogList from "../../Blogs copy/BlogList";
import axios from "axios";


interface datastructure{
  title:string,
  content:string,
  id:number,
  image:string,
  name:String,
}

interface banner{
  title:string,
  content:string,
  id:number,
  image:string,
  pageName:String,
}


const Meetings = () => {

  const[bannerdata, setBannerdata] = useState<banner[]>([]);
  const[pagedata, setPagedata] = useState<datastructure[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<datastructure[]>(
          "https://rmbbackend.rmbjaipur.com/auth/meetingdata",{
            
      });

        console.log('meetingdata data',response.data)
        setPagedata(response.data);
        console.log("meetingdata data in a array",pagedata);
      } catch (error) {
        console.error("meetingdata Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<banner[]>(
          "https://rmbbackend.rmbjaipur.com/auth/meetingbanner",{
            
      });

        console.log('meeting banner data',response.data)
        setBannerdata(response.data);
        console.log("banner data in a array",bannerdata);
      } catch (error) {
        console.error("meeting banner Not Found:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <Header />
      {bannerdata.map((items)=>(
        <div
        className="w-full h-[451px] relative"
        style={{
          backgroundImage: `url(https://rmbbackend.rmbjaipur.com/${items.image.replace(/\\/g, '/')})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        {/* <div className="absolute inset-0  bg-[#02256D] bg-opacity-85 "></div> */}
        <div className="relative z-10 w-[100%] h-[100%] flex flex-col  py-[20px] justify-center items-center">
          <h2 className=" text-center sm:text-[61px] text-[48px] text-[#FDBC12] font-bold ">
            {items.title}{" "}
          </h2>
          <p className="text-[20px] text-[#CBD5E0] text-center lg:w-[80%]">
            {items.content}
          </p>
          <div className="flex bg-[#1E2A3A] border border-[#465468] rounded-md py-2 px-4 mt-4 text-[#64748B]">
            <a
              className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
              href="/"
            >
              {" "}
              <FaHome />
              Home
            </a>
            <a
              className="flex  gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
              href="/meetings"
            >
              {" "}
              <IoIosArrowForward />
              Meetings{" "}
            </a>
          </div>
        </div>
      </div>
      ))}
      
         {/* letst news      */}
         <div className="bg-[#1E2A3A] py-14 px-[8%] ">
        <div className="flex flex-wrap w-[100%]">
          <div className=" sm:w-[50%]">
            <p className="text-[#F1F4F9] text-[16px] font-normal leading-5 mb-4">
              OUR NEWS / EVENTS
            </p>
            <span className="text-[#F1F4F9] text-[39px] leading-10	font-bold	">
              Learn About Our
            </span>
            <span className="text-[39px] leading-10	font-bold	text-[#FDBC12] ml-2">
              Latest News
            </span>
          </div>
          <div className="  sm:w-[50%] md:flex justify-end items-center sm:mt-0 mt-4">
            <button className="bg-[#02256D] w-[150px] py-3 rounded text-[#F1F4F9] text-[16px] font-normal"
            
            >
              View All
            </button>
          </div>
        </div>
        {/* News boxs */}
        
        <BlogList blogs={blogs} />
      </div>
      <div className="bg-[#1E2A3A] py-14 px-[8%] flex flex-wrap  gap-y-8 w-[100%] border-b border-[#465468]">
      {pagedata.filter((items)=>items.name==='Meeting Agenda (2 Meetings Per Month)').map((items)=>(
           <div className="lg:w-[48%] w-[100%] pr-5">
           <h2 className="text-[#FDBC12] text-[39px] font-semibold ">
             Meetings
           </h2>
          
           <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
             {items.title}
           </p>
           <ol className="list-decimal text-[#94A2B8] text-[400] ml-4 mt-4 flex flex-col gap-y-4">
            {items.content.split('</br>').map((list)=>(
             <li>{list}</li>
            ))}
           </ol>
         </div> 
          ))}
        
        <div className="lg:w-[48%] w-[100%]">
        {pagedata
    .filter((item) => item.image?.length !== 0) // Filter items with non-empty images
    .map((item, index) => (
      <div
        key={index}
        className={`w-[100%] flex ${
          index % 2 === 0 ? 'justify-end' : 'justify-start'
        } mt-5`}
      >
        <img className="w-[60%]" src={`https://rmbbackend.rmbjaipur.com/${item.image}`} alt="" />
      </div>
    ))}

        </div>
      </div>
      <div className="bg-[#101729] py-14 px-[8%] flex flex-wrap w-[100%] border-b border-[#465468] ">
        {pagedata.filter((items)=>items.name==='Meeting Schedules').map((item)=>(
          <div className="md:w-[55%] w-[100%]">
          <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
            {item.title}
          </p>
          <ul className="text-[#94A2B8] text-[16px] flex flex-col gap-y-3 mt-3">
            {item.content.split('</br>').map((list)=>(
              <li>
              {list}
            </li>

            ))}
            
            
          </ul>
        </div>
        ))}

{pagedata.filter((items)=>items.name==='Meeting Days In Month').map((item)=>(
           <div className="md:w-[45%] w-[100%] flex md:pl-[60px] md:mt-0 mt-5">
           <div className="w-[1px] h-[156px] bg-[#D9D9D9] mt-5"></div>
           <div className="pl-[80px]">
             <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
              {item.title}
             </p>
             <ul className="text-[#94A2B8] text-[16px] flex flex-col gap-y-3 mt-3">
              {item.content.split('</br>').map((list)=>(
                <li>{list}</li>
              ))}
              
             </ul>
           </div>
         </div>
        ))}        
       
      </div>
      {pagedata.filter((items)=>items.name === 'Designations / Leadership Team and Working Committee Roles').map((items)=>(
        <div className="bg-[#101729] py-14 px-[8%] flex flex-wrap w-[100%] border-b border-[#465468]">
      <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
      {items.title}
          </p>

          <ul className="text-[#94A2B8] text-[16px] flex flex-col gap-y-3 mt-3">
            {items.content.split('</br>').map((list)=>(
              <li>
               
               <b>{list.split(' – ')[0]}</b> - {list.split(' – ')[1]}
            </li>
            ))}
            
          </ul>
      </div>
      ))}
      
      {pagedata.filter((items)=>items.name === 'Meeting Days').map((items)=>(
        <div className="bg-[#101729] py-14 px-[8%] flex flex-wrap w-[100%] border-b border-[#465468]">
      <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
      {items.title}
          </p>

          <ul className="text-[#94A2B8] text-[16px] flex flex-col gap-y-3 mt-3">
            {items.content.split('</br>').map((list)=>(
              <li>
               
               <b>{list.split(' – ')[0]}</b> - {list.split(' – ')[1]}
            </li>
            ))}
            
          </ul>
      </div>
      ))}
      
      <Footer />
    </div>
  );
};

export default Meetings;
